import search from "@/store/modules/tags/search";
import tags from "@/store/modules/tags/tags";

export default {
    namespaced: true,
    modules: {
        search,
        tags,
    },
};
